import { BASE_URL } from 'src/components/10-atoms/seo/constants';
import { NodeType } from '../graphql/common/types/node';
export function inferEPTabID(ancestorsDetails, knownNodes) {
    const subject = knownNodes?.subject ??
        ancestorsDetails?.writtenSubject ??
        ancestorsDetails?.oralsSubject;
    if (subject?.type === NodeType.ORALS_SUBJECT) {
        return 'ORALS';
    }
    if (subject?.type === NodeType.WRITTEN_SUBJECT) {
        return 'WRITTEN';
    }
    const qp = knownNodes?.qp ?? ancestorsDetails?.writtenQP ?? ancestorsDetails?.oralsQP;
    if (qp?.type === NodeType.ORALS_QP) {
        return 'ORALS';
    }
    if (qp?.type === NodeType.WRITTEN_QP) {
        return 'WRITTEN';
    }
    if (ancestorsDetails?.oralsSubject || ancestorsDetails?.oralsQP) {
        return 'ORALS';
    }
    if (ancestorsDetails?.writtenSubject || ancestorsDetails?.writtenQP) {
        return 'WRITTEN';
    }
    return undefined;
}
export function getEPHomeCanonical(examLevelID, tabID) {
    const params = new URLSearchParams();
    if (examLevelID) {
        params.set('examLevelID', examLevelID);
    }
    if (tabID) {
        params.set('tabID', tabID);
    }
    const query = params.toString();
    return query ? `EP_Home?${query}` : 'EP_Home';
}
export function getEPHomeUrl(examLevelID, tabID) {
    return `${BASE_URL}/${getEPHomeCanonical(examLevelID, tabID)}`;
}
